var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
export var TituloPagina = function (_a) {
    var titulo = _a.titulo, subtitulo = _a.subtitulo;
    return (_jsxs(Box, __assign({ marginY: "1.5rem" }, { children: [_jsx(Typography, __assign({ variant: "h5", textAlign: "center" }, { children: titulo })), _jsx(Typography, __assign({ variant: "body2", textAlign: "center", mt: "0.5rem" }, { children: subtitulo }))] })));
};
